import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

interface CancelInvoiceParams {
  invoiceId: Array<string>;
  studentId?: string;
}

export const cancelInvoice = async ({
  invoiceId,
}: CancelInvoiceParams) => {
  const response = await baseAPI.post<unknown>('subscription-invoices/cancel', {
    invoiceId,
  });
  return response.data;
};

export const useCancelInvoiceMutation = () => {
  return useMutation({
    mutationFn: (params: CancelInvoiceParams) => cancelInvoice(params),
    onSuccess: (_, params) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDENT_PAYMENT_HISTORY],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENT_PAYMENTS_HISTORY],
      });
      if (params.studentId) {
        void queryClient.invalidateQueries({
          queryKey: [KEYS.UPCOMING_SUBSCRIPTION_INVOICES, params.studentId],
        });
        void queryClient.invalidateQueries({
          queryKey: [KEYS.TUITION_DETAILS, params.studentId],
        });
        void queryClient.invalidateQueries({
          queryKey: [KEYS.OUTSTANDING_BALANCE, params.studentId],
        });
      } else {
        void queryClient.invalidateQueries({
          queryKey: [KEYS.UPCOMING_SUBSCRIPTION_INVOICES],
        });
        void queryClient.invalidateQueries({
          queryKey: [KEYS.TUITION_DETAILS],
        });
        void queryClient.invalidateQueries({
          queryKey: [KEYS.OUTSTANDING_BALANCE],
        });
      }
      // Cancelled invoices affect AR totals/aging
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_DUE_DATE_GROUPING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_STUDENT_GROUPING],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.OUTSTANDING_BALANCE],
      });
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ACCOUNTS_RECEIVABLE_STUDENT_GROUPING],
      });
    },
  });
};
